// import React, { useState, useEffect } from "react";
// import { Outlet, useNavigate, useLocation } from "react-router-dom";
// import { auth } from "./firebase";
// import "./Layout.css"; // rename Dashboard.css → Layout.css (or keep both)

// export default function Layout() {
//   const [theme, setTheme] = useState("light");
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Apply theme class to body
//   useEffect(() => {
//     document.body.className = `${theme}-theme`;
//   }, [theme]);

//   const toggleTheme = () => {
//     setTheme((prev) => (prev === "light" ? "dark" : "light"));
//   };

//   const navigationItems = [
//     { path: "/dashboard", label: "Dashboard", icon: "📊" },
//     { path: "/logs1", label: "All Logs", icon: "📝" },
//     { path: "/settings/email", label: "Email Capture", icon: "📧" },
//     { path: "/settings", label: "Settings", icon: "⚙️" },
//   ];

//   return (
//     <div className="dashboard-container">
//       {/* SIDEBAR - fixed left */}
//       <aside className="sidebar">
//         <div className="sidebar-header">
//           <h2>📋 LogKeeper</h2>
//         </div>

//         <nav className="sidebar-nav">
//           {navigationItems.map((item) => (
//             <button
//               key={item.path}
//               onClick={() => navigate(item.path)}
//               className={`nav-btn ${
//                 location.pathname === item.path ? "active" : ""
//               }`}
//             >
//               <span className="nav-icon">{item.icon}</span> {item.label}
//             </button>
//           ))}
//         </nav>

//         <div className="sidebar-footer">
//           <button onClick={toggleTheme} className="theme-toggle-btn">
//             {theme === "light" ? "🌙 Dark Mode" : "☀️ Light Mode"}
//           </button>
//           <div className="user-info">
//             <span className="user-email">
//               {auth.currentUser?.email || "User"}
//             </span>
//           </div>
//         </div>
//       </aside>

//       {/* MAIN CONTENT - changes per route */}
//       <main className="main-content">
//         <Outlet />
//       </main>
//     </div>
//   );
// }

























import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { auth } from "./firebase";
import "./Layout.css";

export default function Layout() {
  const [theme, setTheme] = useState("light");
  const navigate = useNavigate();
  const location = useLocation();

  // Apply theme class to body
  useEffect(() => {
    document.body.className = `${theme}-theme`;
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  // Navigation items with NEW, DISTINCT icons
  const navigationItems = [
    { path: "/dashboard", label: "Dashboard", icon: "🏠", badge: null },      // home
    { path: "/logs1", label: "All Logs", icon: "📄", badge: "New" },        // document
    { path: "/settings/email", label: "Email Capture", icon: "📨", badge: null }, // incoming envelope
    { path: "/settings", label: "Settings", icon: "🔧", badge: null },      // wrench
    { path: "/decision-history", label: "decision-history", icon: "🔧", badge: null },      // wrench
  ];

  // Get user initials for avatar
  const getInitials = () => {
    if (!auth.currentUser?.email) return "U";
    const email = auth.currentUser.email;
    return email.charAt(0).toUpperCase();
  };

  // Display name fallback
  const displayName = auth.currentUser?.email || "Guest User";
  const shortEmail = displayName.length > 20 ? displayName.substring(0, 18) + "…" : displayName;

  return (
    <div className="dashboard-container">
      {/* ---------- SIDEBAR – Straight, Separated, Professional ---------- */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <span className="logo-icon">🗂️</span> {/* NEW logo icon */}
          <div>
            <h2>Logitonce</h2>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navigationItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`nav-btn ${
                location.pathname === item.path ? "active" : ""
              }`}
              data-badge={item.badge || null}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          {/* ---------- PROFILE CARD – with avatar and status ---------- */}
          <div className="profile-card">
            <div className="avatar">{getInitials()}</div>
            <div className="profile-info">
              <span className="user-email">{shortEmail}</span>
              <span className="user-role">Admin</span>
            </div>
          </div>

          {/* ---------- THEME TOGGLE – slick switch ---------- */}
          <button onClick={toggleTheme} className="theme-toggle-btn">
            <span className="theme-icon">{theme === "light" ? "🌙" : "☀️"}</span>
            <span>{theme === "light" ? "Dark Mode" : "Light Mode"}</span>
          </button>
        </div>
      </aside>

      {/* ---------- MAIN CONTENT – dynamic pages via Outlet ---------- */}
      <main className="main-content">
        <div className="content-area">
          <Outlet />
        </div>
      </main>
    </div>
  );
}